import { useTitle } from 'hooks';

export default function NotFound() {
    useTitle('Not Found');

    return (
        <div>Page Not Found</div>
    );
}
